import styled from "styled-components";
const StyledColor = styled.div`
    &.color-swatch-color-range,
    &.color-swatch-color-range * {
        box-sizing: border-box;
    }
    &.color-swatch-color-range {
        background: rgba(18, 18, 18, 0.73);
        border-radius: 4px;
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        position: absolute;
        box-shadow: 0px 0px 41.8px 0px rgba(17, 22, 32, 1);
        backdrop-filter: blur(50px);
        z-index: 9;
        width: 613px;
        margin-top: 5px;
    }
    .frame-1000011166 {
        display: flex;
        flex-direction: column;
        gap: 12px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .filter-by-any-color {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
    }
    .frame-1000011165 {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        align-items: flex-start;
        -webkit-box-pack: start;
        justify-content: flex-end;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        flex-direction: row-reverse;
    }
    .ellipse-173 {
        border-radius: 50%;
        flex-shrink: 0;
        width: 37px;
        height: 37px;
        position: relative;
        cursor: pointer;
    }
    .ellipse-173.active {
        border-style: solid;
        border-color: #ffffff;
        border-width: 4px;
    }
    .frame-1000011167 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-end;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .btn-xs-primary {
        background: var(--salmon, #f7665f);
        border-radius: 5px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        height: 30px;
        position: relative;
        cursor: pointer;
    }
    .button {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: var(--button-text-small-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--button-text-small-font-size, 12px);
        line-height: var(--button-text-small-line-height, 16px);
        font-weight: var(--button-text-small-font-weight, 400);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;

export default function Color({
    selectedType,
    setSelectedType,
    selectedColor,
    setSelectedGroup,
    setShowColorFilter,
    toggleColorSelection,
    colorList
}) {
    return (
        <StyledColor className="color-swatch-color-range">
            <div className="frame-1000011166">
                <div className="filter-by-any-color">Filter by: Any color</div>
                <div className="frame-1000011165">
                    {colorList.map((key, value) => {
                        return (
                            <div
                                className={`ellipse-173 ${selectedColor.includes(key.hex_code) ? "active" : ""}`}
                                style={{ background: `${key?.hex_code}` }}
                                onClick={() => toggleColorSelection(key.hex_code)}></div>
                        );
                    })}
                </div>
            </div>
            <div className="frame-1000011167">
                <div
                    className="btn-xs-primary"
                    onClick={e => {
                        e.stopPropagation();
                        setShowColorFilter(false);
                    }}>
                    <div className="button">Done</div>
                </div>
            </div>
        </StyledColor>
    );
}
